"use client";

import { useEffect } from "react";

import { initWebVitalsReporting } from "@/utils/webVitals";

/**
 * Registers Core Web Vitals listeners once and reports to New Relic.
 * Renders nothing; keep mounted near other vendor initializers in ClientLayout.
 */
export function WebVitalsReporter(): null {
  useEffect(() => {
    let cancelled = false;

    void initWebVitalsReporting().catch((error: unknown) => {
      if (cancelled) return;
      // eslint-disable-next-line no-console
      console.error("Failed to initialize web-vitals reporting:", error);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
